import { pick, findIndex, findLastIndex } from 'lodash'

import { swap, randstr } from '../../lib/Tools'
import fixOrder from '../routes/fixOrder.js'

export function canMove(state: Array<Object>, itarget: number, up: boolean): boolean {
  const idst = itarget + (up ? -1 : 1)
  return !(
    itarget == 0 || idst == 0 // la posición 0 está reservada
    || (itarget == 1 && up) // ídem (redundante?)
    || (idst >= state.length && !up)) // TODO review this shit. idst>length should always be an error
}

/**
 * Multi Move: down
 * move 1+ days down
 * Args:
 * - L: list
 * - selection: array of ids
 * Returns:
 * - new list
 */
export function multiMoveDown(L, selection) {
  const ids = new Set(selection)
  const start = findIndex(L, x => ids.has(x.key))
  const next  = findIndex(L, (x => x.type == "day" && !ids.has(x.key)), start)
  const end   = findIndex(L, (x => x.type == "day"), next + 1)

  // 0-start, start-next, next-end, end-len
  // 0-start, next-end, start-next, end-len

  if (start < 0 || next <= 0) {
    return L
  }

  if (end < 0) {
    return [...(L.slice(0, start)), ...(L.slice(next, L.length)), ...(L.slice(start, next))]
  }

  return [...(L.slice(0, start)), ...(L.slice(next, end)), ...(L.slice(start, next)), ...(L.slice(end, L.length))]
}

export function multiMoveUp(L, selection) {
  const ids = new Set(selection)
  const start = findIndex(L, x => ids.has(x.key))
  const end   = findIndex(L, (x => x.type == "day" && !ids.has(x.key)), start)
  const prev = findLastIndex(L, (x => x.type == "day"), start - 1)

  if (start <= 0 || prev < 0) {
    return L
  }

  // START:  0-prev, prev-start, start-length
  // RESULT: 0-prev, start-length, prev-start
  if (end < 0) {
    return [...(L.slice(0, prev)), ...(L.slice(start, L.length)), ...(L.slice(prev, start))]
  }

  // START:  0-prev, prev-start, start-end, end-length
  // RESULT: 0-prev, start-end, prev-start, end-length
  return [...(L.slice(0, prev)), ...(L.slice(start, end)), ...(L.slice(prev, start)), ...(L.slice(end))]
}

export function getNewItem(type, data) {
  const letter = (
    (type == "activity" && "A") || (type == "city" && "C") ||
    (type == "day" && "D") || (type == "expense" && "E") ||
    (type == "note" && "N") || (type == "expense" && "E") ||
    "X"
  )

  if (letter == "X") {
    console.error(`getNewItem received unknown type '${type}'`)
  }

  return { type, key: `${letter}${randstr()}`, ...data }
}

/* hotel movement */

// TODO why the fuck is compose sometimes returning an empty array?
function moveHotelUp(state, itarget) {
  const prevDayStartIdx = findLastIndex(state, ["type", "day"], itarget)
  return (prevDayStartIdx == 0
    ? state
    : [
      ...state.slice(0, prevDayStartIdx),
      state[itarget],
      ...state.slice(prevDayStartIdx, itarget),
      ...state.slice(itarget + 1)
    ])
}
function moveHotelDown(state, itarget) {
  const nextDayStart = findIndex(state, ["type", "day"], itarget)
  return (nextDayStart == -1
    ? state
    : [...state.slice(0, itarget), ...state.slice(itarget + 1, nextDayStart + 1), state[itarget], ...state.slice(nextDayStart + 1)])
}

/* movement of anything */

export function move(agenda, itarget, up) {
  // @TODO this "recollection of expenses" for references is repeated several times throughout the code...
  const expenses = {}
  agenda.forEach(item => { if (item.expense) expenses[item.key] = item.expense })

  const target = agenda[itarget]
  const expense = target.expense || expenses[target.ref]

  return (expense && expense.type == "hotel"
    ? fixOrder((up ? moveHotelUp : moveHotelDown)(agenda, itarget))
    : fixOrder(swap(agenda, itarget, itarget + (up ? -1 : 1))))
}

/* removal */

export function removeItem(state, itarget) {
  const target = state[itarget]

  // head expenses (without reference) are harder to remove
  if (target.type == "expense" && !target.ref) {
    // the first referencer we find will be the new head
    const firstReferencerIdx = findIndex(state, x => x.ref == target.key)
    const firstReferencer = state[firstReferencerIdx]

    if (firstReferencer) {
      return (
        state
          .filter((ignored, i) => i != itarget)
          .map(x => (
            x.key == firstReferencer.key
              ? { ...x, expense: target.expense, key: target.key, ref: null }
              : x
          ))
      )
    }
  }

  return state.filter((_x, i) => i != itarget)
}

/* to apply templates, we need to "salt" keys and refs with a key,
 * so that no 2 items have the same key if you apply the same
 * template twice (or a template that also uses another template... */
export function addKeyToItem(item, ak) {
  if (item.key && item.ref) {
    return {
      ...item,
      key: item.key + ak,
      ref: item.ref + ak
    }
  }
  else if (item.key) {
    return {
      ...item,
      key: item.key + ak
    }
  }
  else {
    console.error(`item with no key; gonna give it a random one (${JSON.stringify(item)})`)
    return {
      ...item,
      key: randstr() + ak
    }
  }
}

export function getRouteActivities(route, activities) {
  return pick(
    activities,
    route.agenda.filter(item => item.type == "activity").map(item => item.id)
  )
}
